export const INTEREST_OPTIONS = [
  { value: 'sport', label: { nl: 'Sport & Beweging', en: 'Sports & Exercise' }, icon: '⚽' },
  { value: 'kunst', label: { nl: 'Kunst en Cultuur', en: 'Art & Culture' }, icon: '🎨' },
  { value: 'muziek', label: { nl: 'Muziek & Dans', en: 'Music & Dance' }, icon: '🎵' },
  { value: 'eten', label: { nl: 'Eten & Koken', en: 'Food & Cooking' }, icon: '🍳' },
  { value: 'natuur', label: { nl: 'Natuur en buiten', en: 'Nature & Outdoors' }, icon: '🌿' },
  { value: 'sociaal', label: { nl: 'Sociaal & Gezelligheid', en: 'Social & Gathering' }, icon: '☕' },
  { value: 'educatie', label: { nl: 'Leren en ondersteuning', en: 'Learning & Support' }, icon: '📚' },
  { value: 'gezondheid', label: { nl: 'Gezondheid', en: 'Health' }, icon: '💚' },
  { value: 'kinderen', label: { nl: 'Kinderen & Familie', en: 'Children & Family' }, icon: '👨‍👩‍👧' },
  { value: 'tech', label: { nl: 'Tech & Digitaal', en: 'Tech & Digital' }, icon: '💻' },
];

export const AVAILABILITY_OPTIONS = [
  { value: 'ochtend', label: { nl: 'Ochtend', en: 'Morning' }, icon: '🌅' },
  { value: 'middag', label: { nl: 'Middag', en: 'Afternoon' }, icon: '☀️' },
  { value: 'avond', label: { nl: 'Avond', en: 'Evening' }, icon: '🌙' },
  { value: 'weekend', label: { nl: 'Weekend', en: 'Weekend' }, icon: '📅' },
  { value: 'flexibel', label: { nl: 'Flexibel', en: 'Flexible' }, icon: '🔄' },
];

export const ACTIVITY_TYPE_LABELS = {
  sport: { label: 'Sport & Beweging', icon: '⚽' },
  kunst: { label: 'Kunst en Cultuur', icon: '🎨' },
  muziek: { label: 'Muziek & Dans', icon: '🎵' },
  eten: { label: 'Eten & Koken', icon: '🍳' },
  natuur: { label: 'Natuur en buiten', icon: '🌿' },
  sociaal: { label: 'Sociaal & Gezelligheid', icon: '☕' },
  educatie: { label: 'Leren en ondersteuning', icon: '📚' },
  gezondheid: { label: 'Gezondheid', icon: '💚' },
  anders: { label: 'Anders', icon: '✨' },
};

// Canonical target_audience options (Phase B) — used by filter dropdowns
// and the create-activity form.
export const TARGET_AUDIENCES = [
  { value: 'Kinderen', labelKey: 'age.children' },
  { value: 'Jongeren', labelKey: 'age.youth' },
  { value: 'Volwassenen', labelKey: 'age.adults' },
  { value: 'Senioren', labelKey: 'age.seniors' },
  { value: 'Iedereen', labelKey: 'age.everyone' },
];

export const DATE_FILTER_OPTIONS = [
  { value: 'today', label: { nl: 'Vandaag', en: 'Today' } },
  { value: 'this_week', label: { nl: 'Deze week', en: 'This week' } },
  { value: 'this_month', label: { nl: 'Deze maand', en: 'This month' } },
  { value: 'next_week', label: { nl: 'Volgende week', en: 'Next week' } },
];

export const HOI_BUUR_LOGO = "/images/hoi-buur-logo.svg";


// Social-media handles for Hoi Buur Almere. Set to empty string to hide the
// corresponding icon in the footer. Update these when the accounts are live.
// Julian/Kirsten can swap these strings without touching component code.
export const HOI_BUUR_SOCIALS = {
  instagram: 'https://www.instagram.com/hoibuuralmere',
  facebook: 'https://www.facebook.com/hoibuuralmere',
  linkedin: '', // LinkedIn-bedrijfspagina bestaat nog niet (gaf 404) — vul aan zodra live
  tiktok: '', // vul aan zodra een TikTok-account bestaat
  youtube: '', // idem
};
